import { TagType } from '../../constants'
import { generatedApi } from '../axilon-v2-api.generated'

export const applyTagOverrides = (api: typeof generatedApi) =>
  api.enhanceEndpoints({
    endpoints: {
      // Mobile app pairing. The list holds currently paired devices; a new
      // pairing revokes the caller's previous pending/claimed one, and DELETE
      // cancels a pending pairing or signs a paired device out.
      listDevicePairings: {
        providesTags: [{ type: TagType.DevicePairing, id: 'LIST' }]
      },
      getDevicePairing: {
        providesTags: (_result, _error, id) => [{ type: TagType.DevicePairing, id }]
      },
      createDevicePairing: {
        invalidatesTags: (_result, error) =>
          error ? [] : [{ type: TagType.DevicePairing, id: 'LIST' }]
      },
      revokeDevicePairing: {
        invalidatesTags: (_result, error, id) =>
          error
            ? []
            : [
                { type: TagType.DevicePairing, id },
                { type: TagType.DevicePairing, id: 'LIST' }
              ]
      },
      // An API key is a service-account user, so key mutations invalidate
      // user tags: the API-keys listing is getUsers with serviceAccounts=only
      // and embeds each account's sessions.
      createApiKey: {
        invalidatesTags: (_result, error) => (error ? [] : [{ type: TagType.User, id: 'LIST' }])
      },
      createUserSession: {
        invalidatesTags: (_result, error, { id }) =>
          error
            ? []
            : [
                { type: TagType.User, id },
                { type: TagType.User, id: 'LIST' }
              ]
      },
      deleteUserSession: {
        invalidatesTags: (_result, error, { id }) =>
          error
            ? []
            : [
                { type: TagType.User, id },
                { type: TagType.User, id: 'LIST' }
              ]
      },
      getUsers: {
        providesTags: (result) =>
          result
            ? [
                ...result.items.map(({ id }) => ({ type: TagType.User as const, id })),
                { type: TagType.User, id: 'LIST' }
              ]
            : [{ type: TagType.User, id: 'LIST' }]
      },
      createUser: {
        invalidatesTags: (_, error) => (error ? [] : [{ type: TagType.User, id: 'LIST' }])
      },
      updateUser: {
        invalidatesTags: (result, error) =>
          error || !result
            ? []
            : [
                { type: TagType.User, id: result.id },
                { type: TagType.User, id: 'LIST' }
              ]
      },
      disableUser: {
        invalidatesTags: (_result, error, id) =>
          error
            ? []
            : [
                { type: TagType.User, id },
                { type: TagType.User, id: 'LIST' },
                { type: TagType.RoleAssignment, id: 'LIST' }
              ]
      },
      enableUser: {
        invalidatesTags: (_result, error, id) =>
          error
            ? []
            : [
                { type: TagType.User, id },
                { type: TagType.User, id: 'LIST' },
                { type: TagType.RoleAssignment, id: 'LIST' }
              ]
      },

      getRoles: {
        providesTags: [{ type: TagType.Role, id: 'LIST' }]
      },
      getRoleAssignments: {
        providesTags: (result) =>
          result
            ? [
                ...result.items.map(({ id }) => ({
                  type: TagType.RoleAssignment as const,
                  id
                })),
                { type: TagType.RoleAssignment, id: 'LIST' }
              ]
            : [{ type: TagType.RoleAssignment, id: 'LIST' }]
      },
      createRoleAssignment: {
        invalidatesTags: (_, error) =>
          error
            ? []
            : [
                { type: TagType.RoleAssignment, id: 'LIST' },
                { type: TagType.User, id: 'LIST' }
              ]
      },
      updateRoleAssignment: {
        invalidatesTags: (_, error) =>
          error
            ? []
            : [
                { type: TagType.RoleAssignment, id: 'LIST' },
                { type: TagType.User, id: 'LIST' }
              ]
      },
      deleteRoleAssignment: {
        invalidatesTags: (_, error) =>
          error
            ? []
            : [
                { type: TagType.RoleAssignment, id: 'LIST' },
                { type: TagType.User, id: 'LIST' }
              ]
      }
    }
  })

export default applyTagOverrides
